<template>
    <div class="checkout-summary-minicart">
        <mini-cart-line-item v-for="item in items" :key="item.id" :item="item" :isGift="isGift" />
    </div>
</template>

<script src="./cart-line-items.js"></script>
